import script from "./AbaMenuLateral.vue?vue&type=script&setup=true&lang=js"
export * from "./AbaMenuLateral.vue?vue&type=script&setup=true&lang=js"

import "./AbaMenuLateral.vue?vue&type=style&index=0&id=c30b5d60&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c30b5d60"]])

export default __exports__